console.log(jQuery().jquery);

var $ = jQuery.noConflict();
